(function IIFE() {
    'use strict';

    /////////////////////////////

    function UserFollowerFactory($resource, Config) {
        'ngInject';

        return $resource(Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/social/subscription/:target/list', {}, {
            list: {
                isArray: false,
                method: 'GET',
                params: {
                    target: 'follower',
                },
            },
        });
    }

    /////////////////////////////

    angular.module('Factories').factory('UserFollowerFactory', UserFollowerFactory);
})();
